<template>

<div class="actions">

    <slot></slot>

</div>

</template>

<script>

export default {

}

</script>

<style scoped>

.actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 40px;
    margin-bottom: 40px;
}

.actions:last-child {
    margin-bottom: 0px;
}

</style>
